import React, { useEffect } from "react";

import { FormLogin, Mensagem } from "./styles";
import { ContainerPublic as Container, OverlayPublic as Overlay } from "../../../styles/GlobalStyles";

function Manutencao() {

  return (
    <Container>
      <Mensagem><h1>Estamos em manutenção, voltaremos às 13hrs</h1></Mensagem>
    </Container>
  );
}

export default Manutencao;
